import styled from 'styled-components'

import Header from 'components/Header'

export const StyledHeader = styled(Header)`
	margin-bottom: 2rem;
`
